import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfileTabBarProps {
  /** Optional className override; merged via `cn()` over the base padding. */
  className?: string;
  children: ReactNode;
}

/**
 * Outer tab-bar wrapper used by entry points whose tabs do NOT need a
 * horizontal scroller (search/profile, jobs/pipeline/profile, the inline
 * candidate skeleton bar). Applies only the canonical
 * `"px-4 py-4 md:px-8 md:py-6"` padding around the tabs.
 *
 * For the arbitrator/task variant that wraps the tabs in a horizontal
 * scroller, see {@link ProfileTabBarScrolling}.
 */
export function ProfileTabBar({ className, children }: ProfileTabBarProps) {
  return (
    <div className={cn("px-4 py-4 md:px-8 md:py-6", className)}>
      {children}
    </div>
  );
}
